import TransferCardElement from "../../assets/transfer-card-element.svg?react";
import { BRIDGE_LABELS, type BridgeType } from "./bridgeConfig";

export function BridgeCard({
  bridgeType,
  displayAmount,
  tokenSymbol,
}: {
  bridgeType: BridgeType;
  displayAmount: number;
  tokenSymbol: string;
}) {
  // TODO: get token address as a prop
  // Derive the token symbol from the token address
  // TODO: get amount as bigint
  // TODO: fetch token decimals from the token address
  // derive the display amount from the amount and token decimals

  const labels = BRIDGE_LABELS[bridgeType];

  const TransferFromIcon = labels.transferFromIcon;
  const TransferToIcon = labels.transferToIcon;

  return (
    <div className="grid *:col-start-1 *:row-start-1 w-full">
      <TransferCardElement className="w-full" />
      <div className="flex items-center w-full">
        <div className="flex flex-col items-center flex-1">
          <TransferFromIcon className="size-8 mb-2" />
          <span className="font-semibold">{labels.transferFrom}</span>
          <span className="text-small text-[#ADC0D0]">
            -{displayAmount} {tokenSymbol}
          </span>
        </div>
        <div className="basis-10" />
        <div className="flex flex-col items-center flex-1">
          <TransferToIcon className="size-8 mb-2" />
          <span className="font-semibold">{labels.transferTo}</span>
          <span className="text-small text-[#ADC0D0]">
            +{displayAmount} {tokenSymbol}
          </span>
        </div>
      </div>
    </div>
  );
}
